import { render, staticRenderFns } from "./ImportDeliveryUpload.vue?vue&type=template&id=2bf1c5ec"
import script from "./ImportDeliveryUpload.vue?vue&type=script&lang=js"
export * from "./ImportDeliveryUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports